import React, { useEffect, useState, useMemo } from "react";
import { Tab, TabItem } from "../../../Reusablecomponents/Tab";
import StyledTable from "../../../Reusablecomponents/UITable/UITable";
import EditIcon from "../../../assets/images/edit-icon.svg";
import DeleteIcon from "../../../assets/images/delete-icon.svg";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  Input,
  Avatar,
  Badge,
  Tooltip,
  Select,
  Switch,
  Row,
  Col,
  Form,
  Spin,
  message,
  Modal,
} from "antd";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons"; // Custom Button component
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../../Reusablecomponents/UIModal/index";
import { CALL_API } from "../../../Common/api";
import {
  ActiontypeEnum,
  OfficeType,
  Reciepenttype,
  EventType,
  FuelTypeEnum,
  statusEnum,
  Transmission,
  FieldTypeEnum,
  RTypeEnum,
  AIConsignmentDeliveryEvents,
  NexusConsignmentEvents,
  ContainerConsignmentEvents,
} from "../../../Common/constant";
import { useSelector } from "react-redux";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { format } from "highcharts";
import dayjs from "dayjs";
import { render } from "@testing-library/react";
import { set } from "immutable";
import LocationPicker from "../../../Reusablecomponents/LocationPicker/LocationPicker";
import VehicleDetails from "./VehicleDetails";
const { Option } = Select;
const StyledInput = styled(Input)`
  width: 312px !important; // Set the desired width
  height: 39px;
  border-radius: 24px;
`;

const Customstyle = styled.div`
  .ant-input {
    border-radius: 10px !important;
  }
  .ant-input-outlined:focus {
    border-color: #d9d9d9 !important;
  }
  background-color: white;

  .topstyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }
  @media (max-width: 480px) {
    .ant-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 7px;
    }
    .ant-tabs-nav-list {
      flex-direction: column;
      margin: 0px 0px 0px 8px;
    }
    .topstyle {
      flex-direction: column;
      gap: 10px;
    }
    .searchstle {
      flex-direction: column;
      align-self: flex-end;
    }
    .total {
      align-self: flex-start;
    }
  }
  .ant-tabs-nav-list {
    margin-top: 20px;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
  }
  .searchstle {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .filterstyle {
    height: 25px;
    width: 25px;
  }
  .badg {
    padding: 6px;
  }
  .custom-row-height {
    height: 88px !important; /* Set desired row height */
  }
  .tablestyle {
    // padding-left: 30px;
  }
  .switc {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .create_btn_customization {
    margin-left: auto;
  }
`;

function MasterTable() {
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const offCreateAllowed = useMemo(
    () => hasPermission("OFFICE", "C"),
    [reduxPermissions],
  );
  const offUpdateAllowed = useMemo(
    () => hasPermission("OFFICE", "U"),
    [reduxPermissions],
  );
  const offDeleteAllowed = useMemo(
    () => hasPermission("OFFICE", "D"),
    [reduxPermissions],
  );

  const vtypeCreateAllowed = useMemo(
    () => hasPermission("VCHTYPE", "C"),
    [reduxPermissions],
  );
  const vtypeUpdateAllowed = useMemo(
    () => hasPermission("VCHTYPE", "U"),
    [reduxPermissions],
  );
  const vtypeDeleteAllowed = useMemo(
    () => hasPermission("VCHTYPE", "D"),
    [reduxPermissions],
  );
  const vehCreateAllowed = useMemo(
    () => hasPermission("VEHICLE", "C"),
    [reduxPermissions],
  );
  const vehUpdateAllowed = useMemo(
    () => hasPermission("VEHICLE", "U"),
    [reduxPermissions],
  );
  const vehDeleteAllowed = useMemo(
    () => hasPermission("VEHICLE", "D"),
    [reduxPermissions],
  );
  const cusCreateAllowed = useMemo(
    () => hasPermission("CUSTFIELD", "C"),
    [reduxPermissions],
  );
  const cusUpdateAllowed = useMemo(
    () => hasPermission("CUSTFIELD", "U"),
    [reduxPermissions],
  );
  const cusDeleteAllowed = useMemo(
    () => hasPermission("CUSTFIELD", "D"),
    [reduxPermissions],
  );
  const evCreateAllowed = useMemo(
    () => hasPermission("EVACTIONS", "C"),
    [reduxPermissions],
  );
  const evUpdateAllowed = useMemo(
    () => hasPermission("EVACTIONS", "U"),
    [reduxPermissions],
  );
  const evDeleteAllowed = useMemo(
    () => hasPermission("EVACTIONS", "D"),
    [reduxPermissions],
  );
                  const officeRead = useMemo(
        () => hasPermission("OFFICE", "R"),
        [reduxPermissions],
      );
                  const vehicleRead = useMemo(
        () => hasPermission("VEHICLE", "R"),
        [reduxPermissions],
      );
                      const vehTypeRead = useMemo(
        () => hasPermission("VCHTYPE", "R"),
        [reduxPermissions],
      );
                      const evActRead = useMemo(
            () => hasPermission("EVACTIONS", "R"),
            [reduxPermissions],
          );
                          const cusFieldRead = useMemo(
            () => hasPermission("CUSTFIELD", "R"),
            [reduxPermissions],
          );
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [vehfilterform] = Form.useForm();
  const [filterform] = Form.useForm();
  const [OfficeForm] = Form.useForm();
  const [vehicleForm] = Form.useForm();
  const [eventActionForm] = Form.useForm();
  const [vehicleTypeForm] = Form.useForm();
  const [customFieldForm] = Form.useForm();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const vehicleType = useSelector((state) => state?.authTracking?.vehicleType);
  const officeLists = useSelector((state) => state?.authTracking?.officeList);
  const respientList = useSelector(
    (state) => state?.authTracking?.respientList,
  );
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  const smstemplate = useSelector((state) => state?.authTracking?.smsTemplate);
  const allEntityList = useSelector(
    (state) => state?.authTracking?.allEntityList,
  );

  const vehicleLists = useSelector((state) => state?.authTracking?.vehicleList);
  const latlongList = useSelector((state) => state?.authTracking?.latlongList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const supllierList = useSelector(
    (state) => state?.authTracking?.supllierList,
  );
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isCustomDeleteModalVisible, setIsCustomDeleteModalVisible] =
    useState(false);

  const [deleteId, setDeleteId] = useState(null);

  const [hoveredRow, setHoveredRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [isEditVehicleType, setIsEditVehicleType] = useState(false);
  const [isEditVehicle, setIsEditVehicle] = useState(false);
  //custom Field
  const [customFieldtotal, setCustomFieldTotal] = useState(0);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldCurrentPage, setCustomFieldCurrentPage] = useState(1);
  const [customFieldpageSize, setCustomFieldPageSize] = useState(10);
  const [isEditCustomField, setEditCustomField] = useState(false);
  const customFieldPageChange = (page, pageSize) => {
    setCustomFieldCurrentPage(page);
    setCustomFieldPageSize(pageSize);
  };

  const customFieldPageSizeChange = (value) => {
    setCustomFieldPageSize(value);
    setCustomFieldCurrentPage(1);
  };
  const [iaView, setIsView] = useState(location.pathname === "/vehicleDetails");

  //event action
  const [eventActiontotal, setEventActionTotal] = useState(0);
  const [eventActionCurrentPage, setEventActionCurrentPage] = useState(1);
  const [eventActionpageSize, setEventActionPageSize] = useState(10);
  const [isEventEdit, setIsEventEdit] = useState(false);

  const EventActionPageChange = (page, pageSize) => {
    setEventActionCurrentPage(page);
    setEventActionPageSize(pageSize);
  };

  const EventActionPageSizeChange = (value) => {
    setEventActionPageSize(value);
    setEventActionCurrentPage(1);
  };

  //vehicle

  const [vehicletotal, setVehicleTotal] = useState(0);
  const [vehicleCurrentPage, setVehicleCurrentPage] = useState(1);
  const [vehiclepageSize, setVehiclePageSize] = useState(10);

  const VehiclePageChange = (page, pageSize) => {
    setVehicleCurrentPage(page);
    setVehiclePageSize(pageSize);
  };

  const VehiclePageSizeChange = (value) => {
    setVehiclePageSize(value);
    setVehicleCurrentPage(1);
  };

  //vehicle Type

  const [vehicleTypetotal, setVehicleTypeTotal] = useState(0);
  const [vehicleTypeCurrentPage, setVehicleTypeCurrentPage] = useState(1);
  const [vehicleTypepageSize, setVehicleTypePageSize] = useState(10);

  const VehicleTypePageChange = (page, pageSize) => {
    setVehicleTypeCurrentPage(page);
    setVehicleTypePageSize(pageSize);
  };

  const VehicleTypePageSizeChange = (value) => {
    setVehicleTypePageSize(value);
    setVehicleTypeCurrentPage(1);
  };

  //Office
  const [officetotal, setOfficeTotal] = useState(0);
  const [officeCurrentPage, setOfficeCurrentPage] = useState(1);
  const [officepageSize, setOfficePageSize] = useState(10);

  const OfficePageChange = (page, pageSize) => {
    setOfficeCurrentPage(page);
    setOfficePageSize(pageSize);
  };

  const OfficePageSizeChange = (value) => {
    setOfficePageSize(value);
    setOfficeCurrentPage(1);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true); // Open the modal
  };
  const handleOpenModal1 = () => {
    setIsModalOpen1(true); // Open the modal
  };
  const handleOpenModal4 = () => {
    setIsModalOpen4(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    form.resetFields();
    setFormData({
      vehicletype: "",
    });
  };
  const handleCloseModal1 = () => {
    setCustomOpen(false);
    setIsModalOpen4(false);
    customFieldForm.resetFields();
    setFormData({
      fieldname: "",
      fieldcode: "",
      fieldtype: "",
      datasource: "",
      maxLength: "",
      regex: "",
      referencetable: "",
      active: "",
      required: "",
    });
    setEditCustomField(false);
  };
  const handleCloseModal4 = () => {
    setIsModalOpen4(false);
    // Do not wipe formData4 to avoid editor losing value on next open
    eventActionForm.resetFields();
  };
  const handleCloseModal5 = () => {
    setIsModalOpen4(false);
    eventActionForm.resetFields(); // Close the modal
    setIsEventEdit(false);
    setFormData4({
      eventtype: "",
      actiontype: "",
      Title: "",
      message: "",
      recipiententitytype: "",
      Additionalrecipient: "",
      smstemplate: "",
      ModuleType: "",
    });
  };

  const handleDeleteVehicleType = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "Delete",
      `mastertable/delete_vehicle_type`,
      {
        VtypeId: id,
      },
    );
    fetchVehicleTypeData();
    setLoading(false);
    message.success("Vehicle Type Deleted Successfully");
  };

  const handleDeleteOffice = async (record) => {
    setLoading(true);
    const { data } = await CALL_API("DELETE", `mastertable/deleteOffice`, {
      UID: userInfo?.UID,
      OFFID: record?.OFFID,
    });
    fetchOfficeData();
    handleCancelOffice();
    setLoading(false);
    message.success("Office Deleted Successfully!");
    setLoading(false);
  };

  const handleDeleteVehicle = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("Delete", `mastertable/delete_vehicles`, {
      VehId: id,
    });
    CustomeDataDelete(id);
    fetchVehicleData();
    setLoading(false);
    message.success("Vehicle Deleted Successfully!");
  };

  const handleDeleteEvent = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("Delete", `mastertable/delete_action`, {
      ActID: id,
    });
    fetchEventActionData();
    setLoading(false);
    message.success("Event Action Deleted Successfully!");
  };

  const OfficeColumn = [
    {
      title: "Office Name",
      dataIndex: "OFFNM",
      key: "OFFNM",
    },
    {
      title: "Office Address",
      dataIndex: "ADDRESS",
      key: "ADDRESS",
    },
    {
      title: "Longitude",
      dataIndex: "LONGITUDES",
      key: "LONGITUDES",
    },
    {
      title: "Latitude",
      dataIndex: "LATITUDE",
      key: "LATITUDE",
    },
    {
      title: "Type",
      dataIndex: "TYPE",
      key: "TYPE",
      render: (text) => {
        const officeType = OfficeType?.find((item) => item?.value === text);
        return officeType?.name || "-";
      },
    },
    {
      title: " ",
      width: 50,
      key: "edit",
      render: (_, record) => (
        <Tooltip title={!offUpdateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            alt="Edit"
            style={{
              cursor: offUpdateAllowed ? "pointer" : "not-allowed",
              width: "22px",
              marginTop: "5px",
            }}
            className="edit-icon"
            onClick={(e) => {
              if (!offUpdateAllowed) return;
              const Location = latlongList?.find(
                (item) => item?.LOCNAME === record?.ADDRESS,
              );
              e.stopPropagation();
              setFormData2({
                officename: record?.OFFNM,
                officetype: record?.TYPE,
                address: record?.ADDRESS ?? "",
                latitude: record?.LATITUDE ?? "",
                longitude: record?.LONGITUDES ?? "",
                addressname: record?.ADDRESS
                  ? {
                      address: record?.ADDRESS,
                      latitude: record?.LATITUDE,
                      longitude: record?.LONGITUDES,
                    }
                  : undefined,
                OFFID: record?.OFFID,
                MCID: record?.MCID,
                UID: record?.UID,
              });
              setIsEditOffice(true);
              setOpen(true);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: " ",
      width: 50,
      key: "delete",
      render: (_, record) => (
        <Tooltip title={!offDeleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            alt="Delete"
            style={{
              cursor: offDeleteAllowed ? "pointer" : "not-allowed",
              width: "18px",
            }}
            className="delete-icon"
            onClick={(e) => {
              if (!offDeleteAllowed) return;
              e.stopPropagation();
              handleDeleteOffice(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];
  const VehicletypeColumn = [
    {
      title: "Vehicle Type",
      dataIndex: "NAME",
      key: "NAME",
    },

    {
      title: " ",
      width: 50,
      key: "edit",
      render: (_, record) => (
        <Tooltip title={!vtypeUpdateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            alt="Edit"
            style={{
              cursor: vtypeUpdateAllowed ? "pointer" : "not-allowed",
              width: "22px",
              marginTop: "5px",
            }}
            className="edit-icon"
            onClick={() => {
              if (!vtypeUpdateAllowed) return;
              setIsEditVehicleType(true);
              setIsModalOpen(true);
              setFormData({
                vehicletype: record?.NAME,
                VtypeId: record?.VTYPEID,
              });
              form.setFieldsValue({
                vehicletype: record?.NAME,
              });
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: " ",
      width: 50,
      key: "delete",
      render: (_, record) => (
        <Tooltip title={!vtypeDeleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            alt="Delete"
            style={{
              cursor: vtypeDeleteAllowed ? "pointer" : "not-allowed",
              width: "18px",
            }}
            className="delete-icon"
            onClick={() => {
              if (!vtypeDeleteAllowed) return;
              handleDeleteVehicleType(record?.VTYPEID);
            }}
          />
        </Tooltip>
      ),
    },
  ];
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME, // ← match raw field name
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  const VehicleColumn = [
    {
      title: "Vehicle No",
      dataIndex: "REGNO",
      key: "REGNO",
    },
    {
      title: "Model",
      dataIndex: "MODEL",
      key: "MODEL",
    },
    {
      title: "Mfg Year",
      dataIndex: "MFGYEAR",
      key: "MFGYEAR",
    },
    {
      title: "Cubic Capacity",
      dataIndex: "CUBICCAPACITY",
      key: "CUBICCAPACITY",
    },
    {
      title: "Tonnes",
      dataIndex: "TONNES",
      key: "TONNES",
    },
    {
      title: "Registration Date",
      dataIndex: "REGDATE",
      key: "REGDATE",
      render: (text, record) => {
        return <>{moment(text).format("Do MMM YYYY") || "-"}</>;
      },
    },

    {
      title: "Entity",
      dataIndex: "ENTID",
      key: "ENTID",
      render: (text) => {
        return allEntityList?.find((item) => item?.ID === text)?.Name || "-";
      },
    },
    {
      title: "Vehicle Type",
      dataIndex: "VTYPEID",
      key: "VTYPEID",
      render: (text) => {
        return vehicleType?.find((item) => item?.ID === text)?.NAME || "-";
      },
    },
    {
      title: "Driver",
      dataIndex: "DRIVER",
      key: "DRIVER",
      render: (value) => {
        return driverList?.find((item) => item?.UID === value)?.FULLNM || "-";
      },
    },
    {
      title: "Mileage",
      dataIndex: "Mileage",
      key: "Mileage",
    },
    {
      title: " ",
      width: 70,
      key: "edit",
      render: (_, record) =>
        hoveredRow === record.key ? (
          <Tooltip title={!vehUpdateAllowed ? "No permission" : ""}>
            <img
              src={EditIcon}
              alt="Edit"
              style={{
                cursor: vehUpdateAllowed ? "pointer" : "not-allowed",
                width: "22px",
                marginTop: "5px",
              }}
              className="edit-icon"
              onClick={(e) => {
                if (!vehUpdateAllowed) return;
                e.stopPropagation();
                setFormData1({
                  VehId: record?.VEHID,
                  vehicleno: record?.REGNO,
                  vehicletype: record?.VTYPEID,
                  model: record?.MODEL,
                  // mfgyear: record?.MFGYEAR && moment(record?.MFGYEAR).isValid()
                  //   ? moment(record?.MFGYEAR).format("YYYY")
                  //   : "",

                  capacity: record?.CUBICCAPACITY,
                  tones: record?.TONNES,
                  link: record?.LINKTO,
                  status: record?.STATUS,
                  // RegistrationDate:
                  //   record?.REGDATE && moment(record?.REGDATE).isValid()
                  //     ? moment(record?.REGDATE).format("DD-MM-YYYY")
                  //     : "",

                  chassisno: record?.CHASISNO,
                  engineno: record?.ENGINENO,
                  transmission: record?.TRANSMISSION,
                  entity: record?.ENTID,
                  UID: record?.CRBY,
                  MCID: record?.MCID,
                  supplier: record?.SUPPLIER,
                  driver: record?.DRIVER,
                  office: record?.OFFID,
                  Deleted: record?.DELETED,
                  cc: record?.CC,
                  mileage: record?.Mileage,
                  odo: record?.OdoResetOn ? dayjs(record?.OdoResetOn) : "",
                  fueltype: record?.FuelType,
                  ConsignorId: record?.CONSIGNORID,
                  RegistrationDate: record.REGDATE ? dayjs(record.REGDATE) : "",
                  mfgyear: record?.MFGYEAR ? dayjs(record?.MFGYEAR) : "",
                  dimension: `${record?.Length}/${record?.Width}/${record?.Height}`,
                });
                setOpen1(true);
                setIsEditVehicle(true);
              }}
            />
          </Tooltip>
        ) : null,
    },
    {
      title: " ",
      width: 70,
      key: "delete",
      render: (_, record) =>
        hoveredRow === record.key ? (
          <Tooltip title={!vehDeleteAllowed ? "No permission" : ""}>
            <img
              src={DeleteIcon}
              alt="Delete"
              style={{
                cursor: vehDeleteAllowed ? "pointer" : "not-allowed",
                width: "18px",
              }}
              className="delete-icon"
              onClick={(e) => {
                if (!vehDeleteAllowed) return;
                e.stopPropagation();
                handleDeleteVehicle(record?.VEHID);
              }}
            />
          </Tooltip>
        ) : null,
    },
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...VehicleColumn];

    if (!customFields || customFields.length === 0) return staticCols;

    const dynamicCols = customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...staticCols, ...dynamicCols];
  }, [VehicleColumn, customFields]);

  const CustomfieldColumn = [
    {
      title: "Field Name",
      dataIndex: "FIELDNAME",
      key: "FIELDNAME",
    },
    {
      title: "Field Code",
      dataIndex: "FIELDCODE",
      key: "FIELDCODE",
    },
    {
      title: "Field Type",
      dataIndex: "FIELDTYPE",
      key: "FIELDTYPE",
      render: (value) => {
        const fieldType = FieldTypeEnum.find((item) => item.value === value);
        return fieldType ? fieldType.name : "Unknown"; // Display the name or "Unknown" if not found
      },
    },
    {
      title: "Required",
      dataIndex: "REQUIRED",
      key: "REQUIRED",
      render: (text) => (text ? "Yes" : "No"), // Convert true/false to Yes/No
    },
    {
      title: "Active",
      dataIndex: "ACTIVE",
      key: "ACTIVE",
      render: (text) => (text ? "Yes" : "No"), // Convert true/false to Yes/No
    },
    {
      title: "Reference Table",
      dataIndex: "REFTABLE",
      key: "REFTABLE",
    },
    {
      title: " ",
      width: 50,
      key: "edit",
      render: (_, record) => (
        <Tooltip title={!cusUpdateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            alt="Edit"
            style={{
              cursor: cusUpdateAllowed ? "pointer" : "not-allowed",
              width: "22px",
              marginTop: "5px",
            }}
            className="edit-icon"
            onClick={() => {
              if (!cusUpdateAllowed) return;
              setEditCustomField(true);
              setCustomOpen(true); // <-- FIX: open the correct drawer
              setFormData({
                CfId: record?.CFID,
                fieldname: record?.FIELDNAME,
                fieldcode: record?.FIELDCODE,
                fieldtype: record?.FIELDTYPE,
                datasource: record?.DATASOURCE,
                regex: record?.REGEX,
                maxLength: record?.MAXLEN,
                required: record?.REQUIRED,
                active: record?.ACTIVE,
                referencetable: record?.REFTABLE,
              });
              form.setFieldsValue({
                fieldname: record?.FIELDNAME,
                fieldcode: record?.FIELDCODE,
                fieldtype: record?.FIELDTYPE,
                datasource: record?.DATASOURCE,
                regex: record?.REGEX,
                maxLength: record?.MAXLEN,
                active: record?.ACTIVE,
                referencetable: record?.REFTABLE,
              });
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: " ",
      width: 50,
      key: "delete",
      render: (_, record) => (
        <Tooltip title={!cusDeleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            alt="Delete"
            style={{
              cursor: cusDeleteAllowed ? "pointer" : "not-allowed",
              width: "18px",
            }}
            className="delete-icon"
            onClick={(e) => {
              if (!cusDeleteAllowed) return;
              e.stopPropagation();
              setDeleteId(record?.CFID);
              setIsCustomDeleteModalVisible(true); // Show the delete confirmation modal
            }}
          />
        </Tooltip>
      ),
    },
  ];
  const EventColumn = [
    {
      title: "Event Type",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text, record) => {
        let moduleType = record?.ModuleType;
        if (Array.isArray(moduleType)) {
          moduleType = moduleType.find((v) => v !== "" && v != null);
        }
        moduleType = Number(String(moduleType).trim());
        let source =
          moduleType === 1
            ? AIConsignmentDeliveryEvents
            : moduleType === 2
              ? EventType
              : moduleType === 3
                ? ContainerConsignmentEvents
                : moduleType === 4
                  ? NexusConsignmentEvents
                  : [];
        const evTypeValue = Number(String(text).trim());
        const found = source.find(
          (item) => Number(item?.value) === evTypeValue,
        );
        return found?.name || "-";
      },
    },
    {
      title: "Module",
      dataIndex: "ModuleType",
      key: "ModuleType",
      render: (text) => {
        const data = modulelabel.find((val) => val?.value === text);
        return data ? data.name : "-";
      },
    },
    {
      title: "Recipient Entity Type",
      dataIndex: "RECPTYPE",
      key: "RECPTYPE",
      render: (text) => {
        if (!text) return "-";
        const types = text.split(","); // e.g., ["C", "D"]
        const names = types
          .map(
            (val) => Reciepenttype?.find((item) => item?.value === val)?.name,
          )
          .filter(Boolean); // remove undefined
        return names.length ? names.join(", ") : "-";
      },
    },
    {
      title: "Action Type",
      dataIndex: "TRIGTYPE",
      key: "TRIGTYPE",
      render: (text) => {
        return (
          ActiontypeEnum?.find((item) => item?.value === text)?.name || "-"
        );
      },
    },
    {
      title: " ",
      width: 50,
      key: "edit",
      render: (_, record) => (
        <Tooltip title={!evUpdateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            alt="Edit"
            style={{
              cursor: evUpdateAllowed ? "pointer" : "not-allowed",
              width: "22px",
              marginTop: "5px",
            }}
            className="edit-icon"
            onClick={(e) => {
              if (!evUpdateAllowed) return;
              e.stopPropagation();

              const editData = {
                eventtype: record?.EVTYPE,
                actiontype: record?.TRIGTYPE,
                Title: stripHtml(record?.TITLE),
                message: stripHtml(record?.MESSAGE),
                recipiententitytype: record?.RECPTYPE
                  ? record.RECPTYPE.split(",")
                  : [],
                Additionalrecipient: record?.RECPLIST
                  ? record.RECPLIST.split(",")
                  : [],
                smstemplate: record?.MSGID,
                ModuleType: record?.ModuleType,
                ActID: record?.ACTID,
              };

              setFormData4(editData); // For other logic if needed
              setIsEventEdit(true);
              setIsModalOpen4(true);
              eventActionForm.resetFields();
              // Update the form fields explicitly on the correct form instance
              eventActionForm.setFieldsValue({
                eventtype: editData?.eventtype,
                actiontype: editData?.actiontype,
                Title: stripHtml(editData?.Title),
                message: stripHtml(editData?.message),
                recipiententitytype: editData?.recipiententitytype,
                Additionalrecipient: editData?.Additionalrecipient,
                smstemplate: editData?.smstemplate,
                ModuleType: editData?.ModuleType,
              });
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: " ",
      width: 50,
      key: "delete",
      render: (_, record) => (
        <Tooltip title={!evDeleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            alt="Delete"
            style={{
              cursor: evDeleteAllowed ? "pointer" : "not-allowed",
              width: "18px",
            }}
            className="delete-icon"
            onClick={(e) => {
              if (!evDeleteAllowed) return;
              e.stopPropagation();
              setDeleteId(record?.ACTID);
              setIsDeleteModalVisible(true);
            }}
          />
        </Tooltip>
      ),
    },
  ];
  // const tabItems = [
  //   { label: "Offices", key: "1" },
  //   { label: "Vehicle Types", key: "2" },
  //   { label: "Vehicles", key: "3", content: "Content of Tab Pane 3" },
  //   { label: "Custom Field", key: "4", content: "Content of Tab Pane 4" },
  //   { label: "Event Action", key: "5", content: "Content of Tab Pane 5" },
  // ];
  const tabItems = [
    { label: "Offices", key: "1", SECCODE: "OFFICE" },
    { label: "Vehicle Types", key: "2", SECCODE: "VCHTYPE" },
    { label: "Vehicles", key: "3", SECCODE: "VEHICLE" },
    { label: "Custom Field", key: "4", SECCODE: "CUSTFIELD" },
    { label: "Event Action", key: "5", SECCODE: "EVACTIONS" },
  ];
  const allowedTabs = tabItems.filter((tab) => {
    if (tab.SECCODE === "OFFICE") return officeRead;
    if (tab.SECCODE === "VCHTYPE") return vehTypeRead;
    if (tab.SECCODE === "VEHICLE") return vehicleRead;
    if (tab.SECCODE === "CUSTFIELD") return cusFieldRead;
    if (tab.SECCODE === "EVACTIONS") return evActRead;
    return false;
  });
  const preferredVehicleTab = allowedTabs.find((tab) => tab.key === "3");
  const defaultTabKey = preferredVehicleTab?.key || allowedTabs[0]?.key;
  const [activekey, setActiveKey] = useState(allowedTabs[0]?.key);
  // useEffect(() => {
  //   if (!defaultTabKey) return;
  //   setActiveKey((prev) => prev || defaultTabKey);
  // }, [defaultTabKey]);
  useEffect(() => {
    const isVehicleDetailsRoute = location.pathname === "/vehicleDetails";
    setIsView(isVehicleDetailsRoute);
    if (
      isVehicleDetailsRoute &&
      preferredVehicleTab &&
      activekey !== preferredVehicleTab.key
    ) {
      setActiveKey(preferredVehicleTab.key);
    }
  }, [location.pathname, preferredVehicleTab, activekey]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [customOpen, setCustomOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [odoval, setOdoval] = useState(dayjs().tz("Asia/Kolkata"));
  const [odoRestval, setOdoRestval] = useState(null);
  const [officeList, setOfficeList] = useState([]);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [customFieldList, setCustomFieldList] = useState([]);
  const [eventActionList, setEventActionList] = useState([]);
  const [isEditOffice, setIsEditOffice] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);

  const [filterValues, setFilterValues] = useState({
    actiontype: "",
    eventtype: "",
    entitytype: "",
  });
  const [filterModalOpen1, setFilterModalOpen1] = useState(false);
  const [filterCount1, setFilterCount1] = useState(0);

  const [filterValues1, setFilterValues1] = useState({
    vtype: "",
    regno: "",
    ftype: "",
    entity: "",
    driver: "",
    status: "",
    model: "",
  });
  const odoValue = vehicleList[0]?.OdoResetOn
    ? dayjs.utc(vehicleList[0].OdoResetOn).tz("Asia/Kolkata")
    : odoval;

  // useEffect(() => {
  //   setOdoRestval(vehicleList[0]?.OdoResetOn);
  // }, [vehicleList[0]?.OdoResetOn]);

  // useEffect(() => {
  //   setFormData1((prevValue) => {
  //     return {
  //       ...prevValue,
  //       odo: vehicleList[0]?.OdoResetOn || odoValue,
  //     };
  //   });
  // }, [vehicleList?.OdoResetOn, odoValue]);

  // Utility: strip HTML tags and convert <br> to newlines
  const stripHtml = (input) => {
    if (input === null || input === undefined) return "";
    let text = String(input)
      .replace(/<br\s*\/?\s*>/gi, "\n")
      .replace(/<p\s*[^>]*>/gi, "")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]+>/g, "");
    text = text
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/\n{3,}/g, "\n\n");
    return text.trim();
  };
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Vehicle`,
      );

      SetAllCustomeData(data);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchVehicleData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAll_vehicles?limit=${vehiclepageSize}&page=${vehicleCurrentPage}&regNo=${
          filterValues1?.regno || ""
        }&model=${filterValues1?.model || ""}&status=${
          filterValues1?.status || ""
        }&vType=${filterValues1?.vtype || ""}&fuelType=${
          filterValues1?.ftype || ""
        }&driver=${filterValues1?.driver || ""}&entity=${
          filterValues1?.entity || ""
        }`,
        {},
      );
      const newData1 = data?.data?.map((vehicleItem) => {
        const enrichedItem = { ...vehicleItem };

        // Match fields by REFID === VehId
        const matchedFields =
          AllCustomeData?.filter(
            (field) => field.REFID === vehicleItem.VehId,
          ) || [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setVehicleList(newData1 || []);
      setVehicleTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  useEffect(() => {
    fetchVehicleData();
  }, []);

  //Custome Field api calling Function

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Vehicle",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data || []);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (VehId, values) => {
    try {
      const customDataList = customFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: VehId,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);
      if (customDataList.length === 0) {
        message.warning("No custom fields to create.");
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setCreateCustomeData([]);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (VehId, values) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        // Find the existing custom data for this field and entity
        const existing = AllCustomeData?.find(
          (item) => item.REFID === VehId && item.CFID === field.CFID,
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: VehId,
            Value: value,
            DataId: existing.DATAID,
          };

          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (VehId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: VehId,
          RefTab: "Vehicle",
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAll_custom?limit=${customFieldpageSize}&page=${customFieldCurrentPage}`,
        {},
      );
      setCustomFieldList(data?.data);
      setCustomFieldTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchOfficeData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAllOffices?limit=${officepageSize}&page=${officeCurrentPage}`,
        {},
      );
      setOfficeList(data?.data);
      setOfficeTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchVehicleTypeData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAllVehicleType?limit=${vehicleTypepageSize}&page=${vehicleTypeCurrentPage}`,
        {},
      );
      setVehicleTypeList(data?.data);
      setVehicleTypeTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const fetchCustomFieldData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAll_custom?limit=${customFieldpageSize}&page=${customFieldCurrentPage}`,
        {},
      );
      setCustomFieldList(data?.data);
      setCustomFieldTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const handleDeleteCustomField = async (id) => {
    setLoading(true);
    await CALL_API("DELETE", `mastertable/delete_custom?CfId=${id}`);
    fetchCustomFieldData();
    setLoading(false);
    message.success("Custom Field Deleted Successfully");
  };

  const fetchEventActionData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `mastertable/getAllEventActions?evType=${filterValues?.eventtype}&trigType=${filterValues?.actiontype}&recpType=${filterValues?.entitytype}&page=${eventActionCurrentPage}&limit=${eventActionpageSize}`,
        {},
      );
      setEventActionList(data?.data);
      setEventActionTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };
  const getFilterCount = () => {
    const count = Object.values(filterValues).filter(
      (val) => val !== undefined && val !== null && String(val).trim() !== "",
    ).length;

    setFilterCount(count);
  };
  useEffect(() => {
    getFilterCount();
    fetchEventActionData();
  }, [filterValues, eventActionpageSize, eventActionCurrentPage]);

  const getFilterCount1 = () => {
    const count = Object.values(filterValues1).filter(
      (val) => val !== undefined && val !== null && String(val).trim() !== "",
    ).length;

    setFilterCount1(count);
  };
  useEffect(() => {
    getFilterCount1();
    fetchVehicleData();
  }, [filterValues1, vehiclepageSize, vehicleCurrentPage]);
  // useEffect(() => {
  //   fetchVehicleData();
  // }, [odoValue, vehicleList[0]?.OdoResetOn]);

  //   useEffect(() => {
  //   fetchVehicleData();
  // }, []);

  const [formData, setFormData] = useState({
    vehicletype: "",
  });
  const [formData2, setFormData2] = useState({
    officename: "",
    officetype: "",
    address: "",
    latitude: "",
    longitude: "",
  });
  const [formData1, setFormData1] = useState({
    vehicleno: "",
    vehicletype: "",
    model: "",
    mfgyear: "",
    dimension: "",
    capacity: "",
    contperson: "",
    designation: "",
    address: "",
    link: "",
    status: "",
    RegistrationDate: "",
    odo: vehicleList[0]?.OdoResetOn
      ? vehicleList[0]?.OdoResetOn
      : odoValue || "",
    chassisno: "",
    mileage: "",
    fueltype: "",
    engineno: "",
    transmission: "",
    entitydate: "",
    supplier: "",
    driver: "",
    office: "",
    entity: "",
  });
  const [formData3, setFormData3] = useState({
    code: "",
    name: "",
    email: "",
  });
  const [formData4, setFormData4] = useState({
    eventtype: "",
    actiontype: "",
    Title: "",
    message: "",
    recipiententitytype: "",
    Additionalrecipient: "",
    smstemplate: "",
    ModuleType: "",
  });
  const showDrawer1 = () => {
    setIsEditOffice(false);
    setOpen(true);
  };
  const showDrawer2 = () => {
    handleCancel1();
    setOpen1(true);
  };
  const showCustomDrawer = () => {
    handleCancel1();
    setEditCustomField(false); // <-- Always reset to create mode
    setFormData({
      fieldname: "",
      fieldcode: "",
      fieldtype: "",
      datasource: "",
      maxLength: "",
      regex: "",
      referencetable: "",
      active: "",
      required: "",
    });
    setCustomOpen(true);
    customFieldForm.resetFields();
  };
  const handleOk = () => {
    setOpen(false);
  };

  const handleCancelCustom = () => {
    setCustomOpen(false);
    customFieldForm.resetFields();
    setFormData({
      vehicletype: "",
    });
  };

  const handleCancelOffice = () => {
    setOpen(false);
    form.resetFields();
    setFormData2({
      officename: "",
      officetype: "",
      address: "",
      latitude: 0,
      longitude: 0,
      addressname: undefined,
    });
    setIsEditOffice(false);
  };
  const handleCancel1 = () => {
    vehicleForm.resetFields();
    setFormData1({
      vehicleno: "",
      vehicletype: "",
      model: "",
      mfgyear: null,
      dimension: "",
      capacity: "",
      contperson: "",
      designation: "",
      address: "",
      link: "",
      status: "",
      RegistrationDate: null,
      odo: null,
      chassisno: "",
      mileage: "",
      fueltype: "",
      engineno: "",
      transmission: "",
      entitydate: "",
      supplier: "",
      driver: "",
      office: "",
      entity: "",
    });
    setIsEditVehicle(false);
    setOpen1(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleChange2 = (e) => {
    setFormData2({ ...formData2, [e.target.name]: e.target.value });
  };
  const handleChangeOffice = (e) => {
    setFormData2({ ...formData2, [e.target.name]: e.target.value });
  };
  const handleChange1 = (e) => {
    setFormData1({ ...formData1, [e.target.name]: e.target.value });
  };

  const handleChange3 = (e) => {
    setFormData3({ ...formData3, [e.target.name]: e.target.value });
  };
  const handleChange4 = (e) => {
    setFormData4({ ...formData4, [e.target.name]: e.target.value });
  };

  const handleSubmitFormOffice = async (values) => {
    try {
      setLoading(true);
      const payload = {
        UID: userInfo?.UID,
        OFFNM: formData2?.officename,
        MCID: userInfo?.MCID,
        ADDRESS: formData2?.address || "",
        LATITUDE: String(formData2?.latitude) || "",
        LONGITUDES: String(formData2?.longitude) || "",
        TYPE: formData2?.officetype,
      };
      const updatepayload = {
        UID: userInfo?.UID,
        OFFID: formData2?.OFFID,
        OFFNM: formData2?.officename,
        MCID: formData2?.MCID,
        ADDRESS: formData2?.address || "",
        LATITUDE: String(formData2?.latitude) || "",
        LONGITUDES: String(formData2?.longitude) || "",
        TYPE: formData2?.officetype,
      };

      const { data } = await CALL_API(
        isEditOffice ? "PATCH" : "POST",
        isEditOffice ? "mastertable/updateOffice" : `mastertable/createOffice`,
        isEditOffice ? updatepayload : payload,
      );
      message.success(
        isEditOffice
          ? "Office updated successfully"
          : "Office created successfully",
      );
      handleCancelOffice();
      fetchOfficeData();
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);
      const payload = {
        Name: values?.vehicletype,
        CrBy: userInfo?.UID,
      };
      const updatepayload = {
        Name: values?.vehicletype,
        VtypeId: formData?.VtypeId,
      };
      const { data } = await CALL_API(
        isEditVehicleType ? "PATCH" : "POST",
        isEditVehicleType
          ? "mastertable/update_vehicle_type"
          : `mastertable/insert_vehicle_type`,
        isEditVehicleType ? updatepayload : payload,
      );
      message.success("Vehicle Type created successfully");
      handleCloseModal();
      fetchVehicleTypeData();
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const handleSubmitForm1 = async () => {
    try {
      const [length, width, height] = formData1?.dimension
        .split("/")
        .map(Number); // Extract numbers

      const volume = length * width * height;
      // Extract only the year from the Manufacturing Year field
      const formattedMfgYear =
        formData1?.mfgyear && dayjs(formData1?.mfgyear).isValid()
          ? dayjs(formData1?.mfgyear).format("YYYY") // Format as a 4-digit year
          : null;

      setLoading(true);
      const payload = {
        RegNo: formData1?.vehicleno,
        VtypeId: formData1?.vehicletype,
        Model: formData1?.model || null,
        MfgYear: formattedMfgYear,
        CubicCapacity: formData1?.capacity,
        Tonnes: formData1?.tones,
        LinkTo: formData1?.link || null,
        Status: formData1?.status || 1,
        RegDate: formData1?.RegistrationDate || null,
        ChasisNo: formData1?.chassisno || null,
        EngineNo: formData1?.engineno || null,
        Transmission: formData1?.transmission || "",
        EntId: formData1?.entity || null,
        CrBy: userInfo?.UID,
        McId: userInfo?.MCID,
        Supplier: formData1?.supplier || null,
        Driver: formData1?.driver || null,
        OffID: formData1?.office || null,
        Deleted: 0,
        CC: formData1?.cc || null,
        Mileage: formData1?.mileage,
        OdoResetOn: formData1?.odo || null,
        FuelType: formData1?.fueltype,
        Length: length,
        Width: width,
        Height: height,
        Volume: volume,
        ConsignorId: null,
      };
      const updatepayload = {
        VehId: formData1?.VehId,
        RegNo: formData1?.vehicleno,
        VtypeId: formData1?.vehicletype,
        Model: formData1?.model || null,
        MfgYear: formattedMfgYear,
        CubicCapacity: formData1?.capacity || null,
        Tonnes: formData1?.tones || null,
        LinkTo: formData1?.link || null,
        Status: formData1?.status || 1,
        RegDate: formData1?.RegistrationDate,
        ChasisNo: formData1?.chassisno || null,
        EngineNo: formData1?.engineno || null,
        Transmission: formData1?.transmission || "",
        EntId: formData1?.entity || null,
        CrBy: userInfo?.UID,
        McId: userInfo?.MCID,
        Supplier: formData1?.supplier || null,
        Driver: formData1?.driver || null,
        OffID: formData1?.office,
        Deleted: 0,
        CC: formData1?.cc,
        Mileage: formData1?.mileage,
        // OdoResetOn: formData1?.odo
        //   ? dayjs(formData1?.odo).format("YYYY-MM-DD")
        //   : null,
        OdoResetOn: formData1?.odo
          ? dayjs(formData1?.odo).format("YYYY-MM-DDTHH:mm:ss")
          : null,
        FuelType: formData1?.fueltype,
        // Length: length,
        // Width: width,
        // Height: height,
        // Volume: volume,
        // ConsignorId: formData1?.ConsignorId,
      };
      const { data, ResponseCode, message: apiMessage } = await CALL_API(
        isEditVehicle ? "PATCH" : "POST",
        isEditVehicle
          ? "mastertable/update_vehicles"
          : "mastertable/insert_vehicles",
        isEditVehicle ? updatepayload : payload,
      );

      // Check API response first
      if (ResponseCode !== 200) {
        setLoading(false);
        message.warning(apiMessage || "Couldn't process the request!");
        return;
      }

      // Extract VehId only if success
      const VehId = isEditVehicle ? formData1?.VehId : data?.VEHID;

      if (VehId) {
        if (!isEditVehicle) {
          await CustomeDataCreate(VehId, formData1);
        } else {
          await CustomeDataUpdate(VehId, formData1);
        }
      }

      message.success(
        isEditVehicle
          ? "Vehicle updated successfully"
          : "Vehicle created successfully"
      );
      handleCancel1();
      GetAllCustomeData();
      fetchVehicleData();
      setLoading(false);
      setIsView(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
    setOpen1(false);
  };

  const editRecord = location.state?.editVehicleRecord;

  useEffect(() => {
    if (!editRecord) return;
    setFormData1({
      VehId: editRecord?.VEHID,
      vehicleno: editRecord?.REGNO,
      vehicletype: editRecord?.VTYPEID,
      model: editRecord?.MODEL,
      capacity: editRecord?.CUBICCAPACITY,
      tones: editRecord?.TONNES,
      link: editRecord?.LINKTO,
      status: editRecord?.STATUS,
      chassisno: editRecord?.CHASISNO,
      engineno: editRecord?.ENGINENO,
      transmission: editRecord?.TRANSMISSION,
      entity: editRecord?.ENTID,
      UID: editRecord?.CRBY,
      MCID: editRecord?.MCID,
      supplier: editRecord?.SUPPLIER,
      driver: editRecord?.DRIVER,
      office: editRecord?.OFFID,
      Deleted: editRecord?.DELETED,
      cc: editRecord?.CC,
      mileage: editRecord?.Mileage,
      odo: editRecord?.OdoResetOn ? dayjs(editRecord?.OdoResetOn) : "",
      fueltype: editRecord?.FuelType,
      ConsignorId: editRecord?.CONSIGNORID,
      RegistrationDate: editRecord.REGDATE ? dayjs(editRecord.REGDATE) : "",
      mfgyear: editRecord?.MFGYEAR ? dayjs(editRecord?.MFGYEAR) : "",
      dimension: `${editRecord?.Length}/${editRecord?.Width}/${editRecord?.Height}`,
    });
    setOpen1(true);
    setIsEditVehicle(true);
    setIsView(false);
    // navigate(location.pathname, { replace: true, state: null });
  }, [editRecord]);

  useEffect(() => {
    const isVehicleDetailsRoute = location.pathname === "/vehicleDetails";
    setIsView(isVehicleDetailsRoute);
    if (
      isVehicleDetailsRoute &&
      preferredVehicleTab &&
      activekey !== preferredVehicleTab.key
    ) {
      setActiveKey(preferredVehicleTab.key);
    }
  }, [location.pathname, preferredVehicleTab, activekey]);
  const handleSubmitForm3 = () => {
    setIsModalOpen1(false);
  };
  const handleSubmitForm4 = async (values) => {
    try {
      setLoading(true);

      const payload = {
        Evtype: values?.eventtype,
        Trigtype: values?.actiontype,
        Title: values?.Title || "",
        Message: values?.message || "",
        Recptype: Array.isArray(values?.recipiententitytype)
          ? values.recipiententitytype.join(",")
          : values.recipiententitytype,
        Recplist: Array.isArray(values?.Additionalrecipient)
          ? values.Additionalrecipient.join(",")
          : (values?.Additionalrecipient || "").replace(/\n/g, ","),
        CrBy: userInfo?.UID,
        McID: userInfo?.MCID,
        MSGID: values?.smstemplate,
        ModuleType: Number(
          Array.isArray(values.ModuleType)
            ? values.ModuleType.find((v) => v !== "" && v != null)
            : values.ModuleType,
        ),
      };
      const updatepayload = {
        ...payload,
        ActID: formData4?.ActID,
      };
      const { data } = await CALL_API(
        isEventEdit ? "PATCH" : "POST",
        isEventEdit ? "mastertable/update_action" : `mastertable/insert_action`,
        isEventEdit ? updatepayload : payload,
      );
      message.success(
        isEventEdit
          ? "Event Action updated successfully!"
          : "Event Action created successfully!",
      );
      setIsEventEdit(false);
      handleCloseModal5();
      fetchEventActionData();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("[getTotalConsignments] error -->", error);
    }
  };
  useEffect(() => {
    if (isModalOpen4 && isEventEdit && formData4) {
      eventActionForm.setFieldsValue({
        eventtype: formData4?.eventtype,
        actiontype: formData4?.actiontype,
        Title: formData4?.Title,
        message: formData4?.message,
        recipiententitytype: formData4?.recipiententitytype,
        Additionalrecipient: formData4?.Additionalrecipient,
        smstemplate: formData4?.smstemplate,
        ModuleType: formData4?.ModuleType,
      });
      if (formData4?.Title) {
        eventActionForm.validateFields(["Title"]);
      }
    }
  }, [isModalOpen4, isEventEdit, formData4]);

  //Custome Field api call function
  const handleSubmitForm5 = async () => {
    try {
      setLoading(true);
      const payload = {
        McId: userInfo?.MCID,
        FieldName: formData?.fieldname,
        FieldCode: formData?.fieldcode,
        FieldType: Number(formData?.fieldtype),
        DataSource: formData?.datasource || null,
        Required: formData?.required ? 1 : 0,
        Active: formData?.active ? 1 : 0,
        RefTable: formData?.referencetable,
        Filter: "SampleFilter",
        CrBy: userInfo?.UID,
        MaxLen: formData?.maxLength || "",
        Regex: formData?.regex || null,
      };
      const updatepayload = {
        CfId: formData?.CfId,
        McId: userInfo?.MCID,
        FieldName: formData?.fieldname,
        FieldCode: formData?.fieldcode,
        FieldType: Number(formData?.fieldtype),
        DataSource: formData?.datasource || null,
        Required: formData?.required ? 1 : 0,
        Active: formData?.active ? 1 : 0,
        RefTable: formData?.referencetable,
        Filter: "SampleFilter",
        CrBy: userInfo?.UID,
        MaxLen: formData?.maxLength || "",
        Regex: formData?.regex || null,
      };
      const { data } = await CALL_API(
        isEditCustomField ? "PATCH" : "POST",
        isEditCustomField
          ? "mastertable/update_custom"
          : `mastertable/insert_custom`,
        isEditCustomField ? updatepayload : payload,
      );
      message.success(
        isEditCustomField
          ? "Custom Field updated Successfully"
          : "Custom Field created successfully",
      );
      setCustomOpen(false);
      handleCloseModal1();
      fetchCustomFieldData();
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const handleSelectChange1 = (field, value) => {
    setFormData1((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const EvernActionSelectChange = (field, value) => {
    setFormData4((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const handleVehicleSelectChange = (field, value) => {
    setFormData1((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const handleOfficeSelectChange = (field, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const [SMSTemplateOptions, setSMSTemplateOptions] = useState([]);

  const fetchSMSTemplateOptions = async () => {
    try {
      const { data } = await CALL_API("GET", "mastertable/msgtemplate", {});
      const options = data?.data?.map((item) => ({
        label: item.Name,
        value: item.ID,
      }));
      setSMSTemplateOptions(options || []);
    } catch (error) {
      console.error("Error fetching SMS templates:", error);
    }
  };

  // useEffect(() => {
  //   if (formData4?.actiontype === 0 && SMSTemplateOptions.length === 0) {
  //     fetchSMSTemplateOptions();
  //   }
  // }, [formData4?.actiontype, SMSTemplateOptions.length]);

  useEffect(() => {
    fetchSMSTemplateOptions();
  }, []);

  const modulelabel = [
    { ID: 1, name: "TrackRight AI", value: 1 },
    { ID: 2, name: "TrackRight AI+", value: 2 },
    { ID: 3, name: "TrackRight AI Cargo", value: 3 },
    { ID: 4, name: "Nexus - TrackRight AI", value: 4 },
  ];

  const [locationModal, setLocationModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const locationClick = (name) => {
    setSelectedItem(name);
    setLocationModal(true);
  };
  const handleLocationSelect = (location) => {
    const lat = location?.center?.[0];
    const lng = location?.center?.[1];
    setFormData2((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        address: location.place_name,
        latitude: lat,
        longitude: lng,
      },
      // Payload expects top-level address, latitude, longitude for office form
      ...(selectedItem === "address"
        ? {
            address: location.place_name,
            latitude: lat ?? "",
            longitude: lng ?? "",
          }
        : {}),
    }));
    setLocationModal(false);
  };

  const AddEditForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [[12, 12], [24]],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Office Name</span>,
              type: "text",
              name: "officename",
              value: formData2?.officename,
              placeholder: "Enter Office Name",
              maxLength: 50,
              validationRules: [
                { required: true, message: "Office Name is required" },
              ],
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Office Type</span>,
              type: "selectwithvalue",
              value: formData2?.officetype,
              options: OfficeType?.map((item) => ({
                value: item.value,
                label: item.name,
              })),
              name: "officetype",
              validationRules: [
                { required: true, message: "Office Type is required" },
              ],
            },
            {},
            {},
          ],
          // Second Row (4 Fields)
          [
            // {
            //   id: 3,
            //   label: "Office Address",
            //   type: "selectwithvalue",
            //   options: Array.isArray(latlongList) && latlongList?.map((item) => ({
            //     value: item.LOCNAME,
            //     label: item.LOCNAME,
            //   })),
            //   name: "address",
            //   placeholder: "Enter Office Address",
            //   validationRules: [
            //     { required: true, message: "Office Address is required" },
            //   ],
            //   disabled: false,
            // },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Address</span>,
              type: "location",
              value: formData2?.address,
              name: "address",
              placeholder: "Enter Address",
              maxLength: 70,
              onChange: handleChange,
            },
            {},
            {},
            {},
          ],
        ],
      },
    ],
  };

  const [vehicleformData, setvehicleFormData] = useState({
    vehicleno: "",
  });

  const RegnohandleChange = (e) => {
    const { name, value } = e.target;
    // Remove all characters except letters and numbers
    const alphaNumeric = value.replace(/[^a-zA-Z0-9]/g, "");
    setvehicleFormData((prev) => ({ ...prev, [name]: alphaNumeric }));
  };
  const AddEditFormvehicle = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: <span style={{ color: "#5F6D8C" }}>Vehicle No</span>,
          type: "text",
          name: "vehicleno",
          placeholder: "Enter Vehicle No",
          maxLength: 12,
          value: vehicleformData.vehicleno,
          onChange: RegnohandleChange,

          // onKeyDown: (e) => {
          //   if (!/[A-Za-z0-9/]/.test(e.key)) {
          //     e.preventDefault();
          //   }
          // },
          validationRules: [
            { required: true, message: "Vehicle No is required" },
            {
              pattern: /^[a-zA-Z0-9]+$/,
              message: "Only letters and numbers are allowed",
            },
          ],
        },
        {
          id: 2,
          label: <span style={{ color: "#5F6D8C" }}>Vehicle Type</span>,
          type: "selectwithvalue",
          name: "vehicletype",
          placeholder: "Enter Vehicle Type",
          options: vehicleType?.map((item) => ({
            value: item.ID,
            label: item.NAME,
          })),
          maxLength: 50,
          validationRules: [
            { required: true, message: "Vehicle type is required" },
          ],
        },
        {
          id: 3,
          label: <span style={{ color: "#5F6D8C" }}>Model</span>,
          type: "text",
          name: "model",
          placeholder: "Enter Model",
          maxLength: 50,
          onKeyDown: (e) => {
            if (!/[A-Za-z0-9/]/.test(e.key)) {
              e.preventDefault();
            }
          },
        },
        {
          id: 4,
          label: <span style={{ color: "#5F6D8C" }}>Manufacturing Year</span>,
          type: "date",
          picker: "year",
          name: "mfgyear",
          format: "YYYY",
          placeholder: "Enter Manufacturing year",
          initialValue: dayjs().startOf("year"),
          validationRules: [
            { required: true, message: "Manufacturing Year is required" },
          ],
        },
      ],
      // Second Row (4 Fields)
      [
        {
          id: 5,
          label: (
            <span style={{ color: "#5F6D8C" }}>
              Internal Dimension of Truck (L/W/H)
            </span>
          ),
          type: "text",
          name: "dimension",
          placeholder: "Enter Dimension of Truck",
          onKeyDown: (e) => {
            if (!/[0-9/]/.test(e.key)) {
              e.preventDefault();
            }
          },
          validationRules: [
            { required: true, message: "Dimension of Truck is required" },
          ],
          disabled: false,
        },
        {
          id: 6,
          label: <span style={{ color: "#5F6D8C" }}>Cubic Capacity</span>,
          type: "number",
          name: "capacity",
          placeholder: "Enter Cubic Capacity",
          onKeyDown: (e) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          },
        },
        {
          id: 7,
          label: (
            <span style={{ color: "#5F6D8C" }}>
              Maximum Load of Capacity (in Kg)
            </span>
          ),
          type: "text",
          name: "cc",
          placeholder: "Enter  Maximum Load of Capacity (in Kg)",
          onKeyDown: (e) => {
            if (!/[0-9.]/.test(e.key)) {
              e.preventDefault();
            }
          },
          validationRules: [
            {
              required: true,
              message: "Maximum Load of Capacity is required",
            },
          ],
        },
        {
          id: 8,
          label: <span style={{ color: "#5F6D8C" }}>Fuel Type</span>,
          type: "selectwithvalue",
          name: "fueltype",
          placeholder: "Enter Fuel Type",
          options: FuelTypeEnum?.map((item) => ({
            value: item.value,
            label: item.name,
          })),
          validationRules: [
            { required: true, message: "Fuel Type is required" },
          ],
        },
      ],
      // Address Row
      [
        {
          id: 9,
          label: <span style={{ color: "#5F6D8C" }}>Tonnes</span>,
          type: "text",
          name: "tones",
          placeholder: "",
          onKeyDown: (e) => {
            if (!/[0-9.]/.test(e.key)) {
              e.preventDefault();
            }
          },
        },
        {
          id: 10,
          label: <span style={{ color: "#5F6D8C" }}>Link to</span>,
          type: "selectwithvalue",
          name: "link",
          placeholder: "Enter Link",
          options: vehicleLists?.map((item) => ({
            value: item.VEHID,
            label: item.REGNO,
          })),
        },
        {
          id: 11,
          label: <span style={{ color: "#5F6D8C" }}>Status</span>,
          type: "selectwithvalue",
          name: "status",
          placeholder: "Enter status",
          options: statusEnum?.map((item) => ({
            value: item.value,
            label: item.name,
          })),
        },
        {
          id: 12,
          label: <span style={{ color: "#5F6D8C" }}>Mileage</span>,
          type: "number",
          name: "mileage",
          placeholder: "Enter Mileage",
          onKeyDown: (e) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          },
          validationRules: [{ required: true, message: "Mileage is required" }],
        },
      ],
      [
        {
          id: 13,
          label: <span style={{ color: "#5F6D8C" }}>ODO Reset On</span>,
          type: "date",
          // picker: "year",
          //  type: "daterange",
          name: "odo",
          format: "DD-MM-YYYY",
          placeholder: "Enter ODO Reset On",
          validationRules: [{ required: false }],
        },

        {
          id: 14,
          label: <span style={{ color: "#5F6D8C" }}>Registration Date</span>,
          type: "date",
          name: "RegistrationDate",
          placeholder: "Enter Registration Date",
          validationRules: [
            { required: true, message: "Registration Date is required" },
          ],
        },
        {
          id: 15,
          label: <span style={{ color: "#5F6D8C" }}>Chassis Number</span>,
          type: "text",
          name: "chassisno",
          placeholder: "Enter Chasis Number",
          onKeyDown: (e) => {
            if (!/^[A-Z0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
        },
        {
          id: 16,
          label: <span style={{ color: "#5F6D8C" }}>Engine Number</span>,
          type: "number",
          name: "engineno",
          placeholder: "Enter Engine Number",
          onKeyDown: (e) => {
            if (!/^[A-Z0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
        },
      ],
      [
        {
          id: 17,
          label: <span style={{ color: "#5F6D8C" }}>Transmission</span>,
          type: "selectwithvalue",
          name: "transmission",
          placeholder: "Enter Transmission",
          options: Transmission?.map((item) => ({
            value: item.value,
            label: item.name,
          })),
          validationRules: [
            { required: true, message: "Transmission is required" },
          ],
        },
        {
          id: 18,
          label: <span style={{ color: "#5F6D8C" }}>Entity</span>,
          type: "selectwithvalue",
          name: "entity",
          placeholder: "Enter Entity",
          options: allEntityList?.map((item) => ({
            value: item.ID || 0,
            label: item.Name || "",
          })),
          validationRules: [{ required: true, message: "Entity is required" }],
        },
        {
          id: 19,
          label: <span style={{ color: "#5F6D8C" }}>Supplier</span>,
          type: "selectwithvalue",
          name: "supplier",
          options: supllierList?.map((item) => ({
            value: item.ID,
            label: item.Name,
          })),
          placeholder: "Enter Supplier",
        },
        {
          id: 20,
          label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
          type: "selectwithvalue",
          name: "driver",
          placeholder: "Enter Driver",
          options: driverList?.map((item) => ({
            value: item.UID,
            label: item.FULLNM,
          })),
        },
        {
          id: 21,
          label: <span style={{ color: "#5F6D8C" }}>Office</span>,
          type: "selectwithvalue",
          name: "office",
          options: officeLists?.map((item) => ({
            value: item.OFFID,
            label: item.OFFNM,
          })),
          placeholder: "Enter Office",
          validationRules: [{ required: true, message: "Office is required" }],
        },
      ],
      [{}, {}, {}],
    ];

    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const RefTable = [
    { name: "Bulk Create", value: "BulkCreate" },
    { name: "Company", value: "Company" },
    { name: "Consign", value: "Consign" },
    { name: "Entity", value: "Entity" },
    { name: "Fuel", value: "Fuel" },
    { name: "AIFuel", value: "AIFuel" },
    { name: "Trip", value: "Trip" },
    { name: "User", value: "User" },
    { name: "Vehicle", value: "Vehicle" },
    { name: "AICONSIGN", value: "AICONSIGN" },
    { name: "AIBulkcreate", value: "AIBulkcreate" },
    { name: "AIconsingmentcreate", value: "AIconsingmentcreate" },
    { name: "Tripmonitoringcreate", value: "Tripmonitoringcreate" },
  ];

  const fieldtype = [
    { value: 1, label: "Dropdown" },
    { value: 2, label: "Textbox" },
    { value: 3, label: "Checkbox" },
  ];

  const ModalForm = {
    pages: [
      {
        colSpan: [6],
        fields: [
          // Field Name & Code
          [
            {
              id: 1,
              label: "Field Name",
              type: "text",
              name: "fieldname",
              placeholder: "Enter Field Name",
              maxLength: 50,
              validationRules: [
                { required: true, message: "Field Name is required" },
              ],
            },
            {
              id: 2,
              label: "Field Code",
              type: "text",
              name: "fieldcode",
              placeholder: "Enter Field Code",
              maxLength: 50,
              validationRules: [
                { required: true, message: "Field Code is required" },
              ],
            },
          ],
          // Field Type
          [
            {
              id: 3,
              label: "Field Type",
              type: "selectwithvalue",
              name: "fieldtype",
              placeholder: "Enter Field Type",
              maxLength: 50,
              options: fieldtype.map((item) => ({
                label: item.label,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Field Type is required" },
              ],
            },
            {
              id: 4,
              label: "Reference Table",
              type: "selectwithvalue",
              name: "referencetable",
              placeholder: "Enter Reference Table",
              validationRules: [
                { required: true, message: "Reference Table is required" },
              ],
              options: RefTable.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            {},
            {},
          ],
          // Conditionally render Data Source
          ...(formData.fieldtype === 1
            ? [
                [
                  {
                    id: 4,
                    label: "Data Source",
                    type: "text",
                    name: "datasource",
                    placeholder: "Enter Data Source",
                    validationRules: [
                      { required: true, message: "Data Source is required" },
                    ],
                  },
                  {},
                ],
              ]
            : []),
          // Conditionally render Max Length and Regex
          ...(formData.fieldtype === 2
            ? [
                [
                  {
                    id: 5,
                    label: "Max Length",
                    type: "number",
                    name: "maxLength",
                    placeholder: "Enter Max Length",
                    validationRules: [
                      { required: true, message: "Max Length is required" },
                    ],
                  },
                  {
                    id: 6,
                    label: "Regex",
                    type: "text",
                    name: "regex",
                    placeholder: "Enter Regex",
                    validationRules: [
                      {
                        required: formData?.required,
                        message: "Regex is required",
                      },
                    ],
                  },
                ],
              ]
            : []),

          // Active and Required switches
          [
            {
              id: 8,
              label: "Active",
              type: "switch",
              name: "active",
            },
            {
              id: 9,
              label: "Required",
              type: "switch",
              name: "required",
            },
            {},
            {},
          ],
        ],
      },
    ],
  };

  const recipientOptions = (() => {
    const action = Number(formData4?.actiontype); // Force to number

    if (Array.isArray(respientList)) {
      if (action === 0) {
        const uniqueUserIds = new Set();
        return respientList
          .filter((item) => {
            if (uniqueUserIds.has(item?.USERID)) return false; // Skip duplicates
            uniqueUserIds.add(item?.USERID);
            return item?.USERID; // Ensure USERID exists
          })
          .map((item) => ({
            label: item?.USERID || "Unknown USERID", // Fallback to "Unknown USERID" if undefined
            value: item?.USERID || "Unknown USERID", // Fallback to "Unknown USERID" if undefined
          }));
      } else if (action === 1) {
        const uniqueEmails = new Set();
        return respientList
          .filter((item) => {
            if (uniqueEmails.has(item?.EMAIL)) return false; // Skip duplicates
            uniqueEmails.add(item?.EMAIL);
            return item?.EMAIL; // Ensure EMAIL exists
          })
          .map((item) => ({
            label: item?.EMAIL || "Unknown EMAIL", // Fallback to "Unknown EMAIL" if undefined
            value: item?.EMAIL || "Unknown EMAIL", // Fallback to "Unknown EMAIL" if undefined
          }));
      }
    }
    return [];
  })();
  const [eventOptions, setEventOptions] = useState([]);

  useEffect(() => {
    let options = [];
    let source = [];
    const moduleType = formData4?.ModuleType;

    const hasType = Array.isArray(moduleType)
      ? (val) => moduleType.includes(val)
      : (val) => moduleType === val;

    if (hasType(1)) {
      source = AIConsignmentDeliveryEvents;
    } else if (hasType(2)) {
      source = EventType;
    } else if (hasType(3)) {
      source = ContainerConsignmentEvents;
    } else if (hasType(4)) {
      source = NexusConsignmentEvents;
    }

    options = source.map((item, index) => ({
      label: item.name,
      value: item.value,
      actualValue: item.value,
    }));

    setEventOptions(options);
  }, [formData4?.ModuleType]);

  const ModalForm2 = {
    pages: [
      {
        fields: [
          [
            {
              id: "Module",
              label: "Module",
              type: "selectwithvalueandcheckbox",
              name: "ModuleType",
              options: modulelabel.map((item, index) => ({
                label: item?.name,
                value: item?.value,
              })),
              value: formData4.ModuleType,
              validationRules: [
                { required: true, message: "Module is required" },
              ],
            },
            {
              id: "Eventtype",
              label: "Event Type",
              type: "selectwithvalue",
              name: "eventtype",
              options: eventOptions,
              validationRules: [
                { required: true, message: "Event Type is required" },
              ],
            },
            {
              id: "Action",
              label: "Action",
              type: "selectwithvalue",
              name: "actiontype",
              options: ActiontypeEnum?.map((item) => ({
                label: item?.name,
                value: item?.value,
              })),
              validationRules: [
                { required: true, message: "Action Type is required" },
              ],
            },
            {
              id: "recipiententitytype",
              label: "Recipient Entity Type",
              type: "selectwithvalue",
              name: "recipiententitytype",
              options: Reciepenttype?.map((item) => ({
                label: item?.name,
                value: item?.value,
              })),
              mode: "multiple",
              validationRules: [
                {
                  required: false,
                  message: "Recipient Entity type is required",
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Additional Recipient",
              type: "textareaMultiple",
              name: "Additionalrecipient",
              options: recipientOptions,
            },
            {},
            {},
            {},
          ],
          ...(formData4?.actiontype === 0 // SMS
            ? [
                [
                  {
                    id: 5,
                    label: "SMS Template",
                    type: "selectwithvalue",
                    name: "smstemplate",
                    options: smstemplate?.map((item) => ({
                      value: item.ID,
                      label: item.Name,
                    })),
                    placeholder: "Select SMS Template",
                    validationRules: [
                      { required: false, message: "SMS Template is required" },
                    ],
                  },
                ],
                [
                  {
                    id: 6,
                    label: "Message",
                    type: "text",
                    name: "message",
                    placeholder: "Enter your SMS message",
                    validationRules: [
                      {
                        required: true,
                        message: "Please enter your SMS message",
                      },
                    ],
                  },
                ],
              ]
            : []),
          ...(formData4?.actiontype === 1 // EMAIL
            ? [
                [
                  {
                    id: 7,
                    label: (
                      <>
                        <span style={{ color: "red" }}>*</span>
                        Subject
                      </>
                    ),
                    type: "editorWithMentions",
                    name: "Title",
                    placeholder: "Enter Email Subject",
                    validationRules: [
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.reject(
                              new Error("Subject is required"),
                            );
                          }
                          const textContent = stripHtml(value);
                          if (!textContent || textContent.trim() === "") {
                            return Promise.reject(
                              new Error("Subject is required"),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ],
                  },
                ],
                [
                  {
                    id: 8,
                    label: (
                      <>
                        <span style={{ color: "red" }}>*</span>
                        Message (Type @ for Tags)
                      </>
                    ),
                    type: "editorWithMentions",
                    name: "message",
                    placeholder: "Enter your message",
                    validationRules: [
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.reject(
                              new Error("Message is required"),
                            );
                          }
                          const textContent = stripHtml(value);
                          if (!textContent || textContent.trim() === "") {
                            return Promise.reject(
                              new Error("Message is required"),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ],
                  },
                ],
              ]
            : []),
        ],
        colSpan: [6],
      },
    ],
  };

  useEffect(() => {
    fetchVehicleData();
    fetchOfficeData();
    fetchCustomData();
    fetchVehicleTypeData();
    fetchEventActionData();
  }, [
    officeCurrentPage,
    officepageSize,
    vehicleTypeCurrentPage,
    vehicleTypepageSize,
    vehicleCurrentPage,
    vehiclepageSize,
    eventActionCurrentPage,
    eventActionpageSize,
    customFieldCurrentPage,
    customFieldpageSize,
  ]);
  useEffect(() => {
    loadCustomFields();
    GetAllCustomeData();
  }, []);
  return (
    <>
      <Customstyle>
        <>
          {/* <Tab defaultActiveKey="1" items={tabItems} onChange={setactivekey} /> */}
          {!iaView && (
            <Tab
              activeKey={activekey}
              defaultActiveKey={allowedTabs[0]?.key} // first allowed tab
              items={allowedTabs.map((tab) => ({
                key: tab.key,
                label: tab.label,
              }))}
              onChange={setActiveKey}
            />
          )}
          <div className="px-3">
            {activekey === "1" &&(
              <div className="topstyle">
                <div className="total">{officetotal} Offices</div>
                <div className="searchstle">
                  <Tooltip title={!offCreateAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      className="create_btn_customization"
                      type="primary"
                      onClick={showDrawer1}
                      disabled={!offCreateAllowed}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            )}
            {activekey === "2" &&(
              <div className="topstyle">
                <div className="total">{vehicleTypetotal} Vehicle Types</div>
                <div className="searchstle">
                  <Tooltip title={!vtypeCreateAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      disabled={!vtypeCreateAllowed}
                      type="primary"
                      onClick={handleOpenModal}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            )}
            {!iaView && activekey === "3" && (
              <div className="topstyle">
                <div className="total">{vehicletotal} Vehicles</div>
                <div className="searchstle">
                  <Badge
                    count={filterCount1}
                    className="badg"
                    onClick={() => setFilterModalOpen1(true)}
                  >
                    <Avatar
                      shape="circle"
                      size="large"
                      src={filtericon}
                      className="filterstyle"
                      style={{ cursor: "pointer" }}
                    />
                  </Badge>
                  <Tooltip title={!vehCreateAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      disabled={!vehCreateAllowed}
                      type="primary"
                      onClick={showDrawer2}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            )}
            {activekey === "4" && (
              <div className="topstyle">
                <div className="total">{customFieldtotal} Custom Fields</div>
                <div className="searchstle">
                  <Tooltip title={!cusCreateAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      disabled={!cusCreateAllowed}
                      type="primary"
                      onClick={showCustomDrawer}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            )}
            {activekey === "5" && (
              <div className="topstyle">
                <div className="total">{eventActiontotal} Event Actions</div>
                <div className="searchstle">
                  <Badge
                    count={filterCount}
                    className="badg"
                    onClick={() => setFilterModalOpen(true)}
                  >
                    <Avatar
                      shape="circle"
                      size="large"
                      src={filtericon}
                      className="filterstyle"
                      style={{ cursor: "pointer" }}
                    />
                  </Badge>
                  <Tooltip title={!evCreateAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      disabled={!evCreateAllowed}
                      type="primary"
                      onClick={handleOpenModal4}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            )}
            {activekey === "1" && (
              <div className="tablestyle">
                <Spin spinning={loading}>
                  {officeList?.length > 0 && (
                    <StyledTable
                      dataSource={officeList}
                      columns={OfficeColumn}
                      pagination={false}
                    />
                  )}
                  <ReusablePagination
                    pageSize={officepageSize}
                    handlePageSizeChange={OfficePageSizeChange}
                    currentPage={officeCurrentPage}
                    total={officetotal}
                    handlePageChange={OfficePageChange}
                  />
                </Spin>
              </div>
            )}
            {activekey === "2" && (
              <div className="tablestyle">
                <Spin spinning={loading}>
                  {vehicleTypeList?.length > 0 && (
                    <StyledTable
                      dataSource={vehicleTypeList}
                      columns={VehicletypeColumn}
                      pagination={false}
                    />
                  )}
                  <ReusablePagination
                    pageSize={vehicleTypepageSize}
                    handlePageSizeChange={VehicleTypePageSizeChange}
                    currentPage={vehicleTypeCurrentPage}
                    total={vehicleTypetotal}
                    handlePageChange={VehicleTypePageChange}
                  />
                </Spin>
              </div>
            )}
            {!iaView && activekey === "3" && (
              <div className="tablestyle">
                <Spin spinning={loading}>
                  {vehicleList?.length > 0 && (
                    <StyledTable
                      dataSource={vehicleList}
                      columns={combinedColumns}
                      pagination={false}
                      style={{ cursor: "pointer" }}
                      rowClassName={() => "custom-row-height"}
                      onRow={(record) => ({
                        onClick: () => {
                          setIsView(true);
                          navigate(`/vehicleDetails`, {
                            state: { ...record },
                          });
                        },
                        onMouseEnter: () => setHoveredRow(record.key),
                        onMouseLeave: () => setHoveredRow(null),
                      })}
                    />
                  )}
                  <ReusablePagination
                    pageSize={vehiclepageSize}
                    handlePageSizeChange={VehiclePageSizeChange}
                    currentPage={vehicleCurrentPage}
                    total={vehicletotal}
                    handlePageChange={VehiclePageChange}
                  />
                </Spin>
              </div>
            )}
            {activekey === "4" && (
              <div className="tablestyle">
                <Spin spinning={loading}>
                  {customFieldList?.length > 0 && (
                    <StyledTable
                      dataSource={customFieldList}
                      columns={CustomfieldColumn}
                      pagination={false}
                    />
                  )}
                  <ReusablePagination
                    pageSize={customFieldpageSize}
                    handlePageSizeChange={customFieldPageSizeChange}
                    currentPage={customFieldCurrentPage}
                    total={customFieldtotal}
                    handlePageChange={customFieldPageChange}
                  />
                </Spin>
              </div>
            )}
            {activekey === "5" && (
              <div className="tablestyle">
                <Spin spinning={loading}>
                  {eventActionList?.length > 0 && (
                    <StyledTable
                      dataSource={eventActionList}
                      columns={EventColumn}
                      pagination={false}
                    />
                  )}
                  <ReusablePagination
                    pageSize={eventActionpageSize}
                    handlePageSizeChange={EventActionPageSizeChange}
                    currentPage={eventActionCurrentPage}
                    total={eventActiontotal}
                    handlePageChange={EventActionPageChange}
                  />
                </Spin>
              </div>
            )}
          </div>
        </>

        {iaView && (
          <VehicleDetails
            setIsView={setIsView}
            setFormData1={setFormData1}
            setOpen1={setOpen1}
            setIsEditVehicle={setIsEditVehicle}
            iaView={iaView}
          />
        )}
        <Modal
          open={filterModalOpen}
          onCancel={() => setFilterModalOpen(false)}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                setFilterValues({
                  actiontype: "",
                  eventtype: "",
                  entitytype: "",
                });
                filterform.setFieldsValue({
                  actiontype: "",
                  eventtype: "",
                  entitytype: "",
                });
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount})
                </h6>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={filterform}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              setFilterValues(allvalues);
            }}
            initialValues={filterValues}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Action Type" name="actiontype">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {ActiontypeEnum.map((item) => (
                      <Option
                        key={item.value}
                        value={item.value}
                        label={item.name}
                      >
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Event Type" name="eventtype">
                  <Select
                    className="w-100"
                    allowClear
                    showSearch
                    placeholder=""
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {EventType.map((item) => (
                      <Select.Option
                        key={item.value}
                        value={item.value}
                        label={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Entity Type" name="entitytype">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {Reciepenttype.map((item) => (
                      <Option
                        key={item.value}
                        value={item.value}
                        label={item.name}
                      >
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Modal
          open={filterModalOpen1}
          onCancel={() => setFilterModalOpen1(false)}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                setFilterValues1({
                  vtype: "",
                  regno: "",
                  ftype: "",
                  entity: "",
                  driver: "",
                  status: "",
                  model: "",
                });
                vehfilterform.setFieldsValue({
                  vtype: "",
                  regno: "",
                  ftype: "",
                  entity: "",
                  driver: "",
                  status: "",
                  model: "",
                });
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount1})
                </h6>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={vehfilterform}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              setFilterValues1(allvalues);
            }}
            initialValues={filterValues1}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle No" name="regno">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle Type" name="vtype">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {vehicleType?.map((item) => (
                      <Option
                        key={item.value}
                        value={item.ID}
                        label={item.NAME}
                      >
                        {item.NAME}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Driver" name="driver">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {driverList?.map((item) => (
                      <Option
                        key={item.value}
                        value={item.UID}
                        label={item.FULLNM}
                      >
                        {item.FULLNM}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Model" name="model">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Fuel Type" name="ftype">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {FuelTypeEnum?.map((item) => (
                      <Option
                        key={item.value}
                        value={item.value}
                        label={item.name}
                      >
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Entity" name="entity">
                  <Select
                    className="w-100"
                    allowClear
                    showSearch
                    placeholder=""
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {allEntityList?.map((item) => (
                      <Select.Option
                        key={item.value || 0}
                        value={item.ID || 0}
                        label={item.Name || ""}
                      >
                        {item.Name || ""}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Status" name="status">
                  <Select
                    className="w-100"
                    allowClear={true}
                    showSearch
                    suffixIcon={null}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {statusEnum?.map((item) => (
                      <Option
                        key={item.value}
                        value={item.value}
                        label={item.name}
                      >
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <ReusableDrawer
          title={isEditOffice ? "Updating Office" : "Creating Office"}
          open={open}
          setOpen={setOpen}
          onCancel={handleCancelOffice}
          footer={[
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent onClick={handleCancelOffice}>
                Cancel
              </Buttontransparent>
              <ButtonFilled loading={loading} onClick={handleSubmitFormOffice}>
                {isEditOffice ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
          children={
            <GridBuilder
              formStructureJson={AddEditForm}
              handleChange={handleChange2}
              formSubmit={handleSubmitFormOffice}
              handleSelectChange={handleOfficeSelectChange}
              initialValues={formData2}
              form={form}
              locationClick={locationClick}
            />
          }
        />
        <ReusableDrawer
          title={isEditVehicle ? "Updating Vehicle" : "Creating Vehicles"}
          open={open1}
          setOpen={setOpen1}
          onCancel={handleCancel1}
          footer={[
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent
                key="cancel"
                className="cancel-btn"
                onClick={() => {
                  handleCancel1();
                }}
                style={{
                  borderRadius: "26px",
                  backgroundColor: "#E8FFEC",
                  color: "#2C963D",
                  borderColor: "#E8FFEC",
                  width: "118px",
                  height: "38px",
                }}
              >
                Cancel
              </Buttontransparent>
              <ButtonFilled
                loading={loading}
                key="create"
                type="primary"
                onClick={() => {
                  vehicleForm.submit();
                }}
                style={{
                  backgroundColor: "#2C963D",
                  borderRadius: "26px",
                  borderColor: "#2C963D",
                  width: "118px",
                  height: "38px",
                }}
              >
                {isEditVehicle ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
          children={
            <>
              <GridBuilder
                formStructureJson={AddEditFormvehicle}
                handleChange={handleChange1}
                formSubmit={handleSubmitForm1}
                initialValues={formData1}
                handleSelectChange={handleVehicleSelectChange}
                form={vehicleForm}
                isModalOpen={open1}
              />
            </>
          }
        />
        <UIModal
          header={
            isEditVehicleType
              ? "Updating Vehicle Type"
              : "Creating Vehicle Type"
          }
          open={isModalOpen}
          onClose={handleCloseModal}
          footer={[
            <div
              key="footer"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent onClick={handleCloseModal}>
                Cancel
              </Buttontransparent>
              <ButtonFilled
                loading={loading}
                onClick={() => vehicleTypeForm.submit()}
              >
                {isEditVehicleType ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
          size="550px"
          closeButton={false}
        >
          <div className="p-3">
            <Form
              form={vehicleTypeForm}
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 24 }}
              layout="vertical"
              style={{ paddingBottom: "150px" }}
              onFinish={handleSubmitForm}
              initialValues={formData}
            >
              <Form.Item
                label="Title of the Vehicle Type"
                name="vehicletype"
                rules={[
                  { required: true, message: "Vehicle Type is required" },
                  {
                    pattern: /^[a-zA-Z0-9\s]+$/,
                    message:
                      "Only alphabetic characters, numbers, and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Form>
          </div>
        </UIModal>
        <ReusableDrawer
          title={
            isEventEdit ? "Updating Event Action" : "Creating Event Action"
          }
          open={isModalOpen4}
          setOpen={setIsModalOpen4} // Pass the state setter to control the drawer
          onCancel={handleCloseModal5}
          footer={[
            <div
              key="footer"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent onClick={handleCloseModal5}>
                Cancel
              </Buttontransparent>
              <ButtonFilled
                loading={loading}
                onClick={() => {
                  eventActionForm?.submit();
                }}
              >
                {isEventEdit ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
        >
          <Customstyle>
            <GridBuilder
              formStructureJson={ModalForm2}
              handleChange={handleChange4}
              formSubmit={handleSubmitForm4}
              initialValues={formData4}
              handleSelectChange={EvernActionSelectChange}
              form={eventActionForm}
              isModalOpen={isModalOpen4}
            />
          </Customstyle>
        </ReusableDrawer>

        <UIModal
          width={500}
          open={isCustomDeleteModalVisible}
          onClose={() => {
            setIsCustomDeleteModalVisible(false);
            setDeleteId(null); // Reset the delete ID
          }}
          closeButton={false}
          size="md"
          header={false}
          footer={false}
        >
          <div className="text-center">
            <h1>Are you sure,</h1>
            <h6>You want to delete this Custom Field?</h6>
            <div className="mt-2 w-100 d-flex justify-content-center">
              <ButtonFilled
                onClick={() => {
                  handleDeleteCustomField(deleteId); // Call the delete function with the selected ID
                  setIsCustomDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                Yes
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsCustomDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                No
              </Buttontransparent>
            </div>
          </div>
        </UIModal>

        <UIModal
          width={500}
          open={isDeleteModalVisible}
          onClose={() => {
            setIsDeleteModalVisible(false);
            setDeleteId(null); // Reset the delete ID
          }}
          closeButton={false}
          size="md"
          header={false}
          footer={false}
        >
          <div className="text-center">
            <h1>Are you sure,</h1>
            <h6>You want to delete this Event Action?</h6>
            <div className="mt-2 w-100 d-flex justify-content-center">
              <ButtonFilled
                onClick={() => {
                  handleDeleteEvent(deleteId); // Call the delete function with the selected ID
                  setIsDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                Yes
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                No
              </Buttontransparent>
            </div>
          </div>
        </UIModal>
        <ReusableDrawer
          title={
            isEditCustomField
              ? "Updating Custom Field"
              : "Creating Custom Field"
          }
          open={customOpen}
          setOpen={setCustomOpen} // Pass the state setter to control the drawer
          onCancel={handleCloseModal1}
          footer={[
            <div
              key="footer"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent onClick={handleCloseModal1}>
                Cancel
              </Buttontransparent>
              <ButtonFilled
                onClick={() => {
                  customFieldForm?.submit();
                }}
              >
                {isEditCustomField ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
        >
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleChange}
            formSubmit={handleSubmitForm5}
            initialValues={formData}
            handleSelectChange={handleSelectChange}
            form={customFieldForm}
            isModalOpen={isModalOpen1}
          />
        </ReusableDrawer>
        <LocationPicker
          visible={locationModal}
          onClose={() => setLocationModal(false)}
          onSelect={handleLocationSelect}
        />
      </Customstyle>
    </>
  );
}

export default MasterTable;
